
import { hygraphSrcset } from "@/utils/hygraphImage";
import { WIDE_SIZES, WIDE_WIDTHS } from "@/components/blog/imageSlots";

const RATIOS = { RATIO_16_9: "16 / 9", RATIO_9_16: "9 / 16" };

export default {
  name: "VideoEmbed",
  props: {
    block: { type: Object, required: true },
  },
  data() {
    return {
      playing: false,
      hidden: false,
      thumbFallback: false, // maxresdefault → hqdefault
      WIDE_SIZES,
    };
  },
  computed: {
    ratio() {
      return RATIOS[this.block.aspectRatio] || "16 / 9";
    },
    thumb() {
      // An override the CMS could not resolve comes back with an empty url; fall
      // through to the YouTube thumbnail rather than rendering src="".
      if (this.block.thumbnailOverride && this.block.thumbnailOverride.url) {
        return this.block.thumbnailOverride.url;
      }
      const quality = this.thumbFallback ? "hqdefault" : "maxresdefault";
      return `https://i.ytimg.com/vi/${this.block.videoId}/${quality}.jpg`;
    },
    // Only a Hygraph override can be resized; the YouTube fallback thumbnails
    // come from i.ytimg.com at fixed sizes, so srcset stays off for those.
    thumbSrcset() {
      return hygraphSrcset(this.block.thumbnailOverride, WIDE_WIDTHS);
    },

    // Intrinsic size, so the box is reserved before the image arrives. YouTube
    // serves these two filenames at fixed dimensions — maxresdefault is 16:9,
    // hqdefault is 4:3. The wrapper's CSS aspect-ratio still governs layout;
    // these only stop the browser guessing while the file is in flight.
    thumbSize() {
      // Must agree with `thumb`: an unresolvable override falls back to YouTube,
      // so its (null) dimensions must not be reported as the box size.
      const o = this.block.thumbnailOverride;
      if (o && o.url && o.width) return { width: o.width, height: o.height };
      return this.thumbFallback
        ? { width: 480, height: 360 }
        : { width: 1280, height: 720 };
    },
    iframeSrc() {
      return `https://www.youtube-nocookie.com/embed/${this.block.videoId}?autoplay=1&rel=0`;
    },
  },
  methods: {
    play() {
      if (this.block.videoId) this.playing = true;
    },
    // Decision 6.11: hide a truly-broken video. maxresdefault 404s for many
    // valid videos, so fall back to hqdefault first; only hide if that fails too.
    onThumbError() {
      if (this.block.thumbnailOverride) {
        this.hidden = true;
      } else if (!this.thumbFallback) {
        this.thumbFallback = true;
      } else {
        this.hidden = true;
      }
    },
  },
};
